<template>
  <div class="busi1-page busi-detail">
    <section class="banner">
      <h1>智电设计服务</h1>
      <p>
        九恒在用电专业领域积累了丰富的设计经验，帮助客户规划未来5-15年的用电系统发展和建设方案。在220kV及以下电压等级的送变电项目以及新能源、新基建领域的电力设计中，为客户提供从电力规划、电力咨询到电气设计的电力一站式优质服务。
        <a href="https://www.wjx.cn/vm/t9gPiBR.aspx#" target="_blank">立即咨询</a>
      </p>
    </section>
    <h2>智电规划</h2>
    <p>在满足客户当前负荷增长需要的前提下，公司结合电力经济性和可靠性要求，对区域近期及远期的用电负荷进行预测，同时结合客户的未来规划，对变电站、高压输电线路网架结构及中压配网网架结构等进行建设规划，以满足客户用电安全、节电高效的需求。</p>
    <ul class="img">
      <li><h3>风/光新能源设计</h3></li>
      <li><h3>园区电网规划</h3></li>
      <li><h3>高压/中压电网规划</h3></li>
      <li><h3>负荷预测</h3></li>
    </ul>
    <h2>电力咨询</h2>
    <p>根据客户电力项目建设不同阶段的需求，为客户提供系列电力咨询服务。</p>
    <ul class="icon">
      <li>项目建议书编制</li>
      <li>可行性研究报告编制</li>
      <li>供用电手续咨询</li>
      <li>供电方案咨询</li>
      <li>用电评估咨询</li>
    </ul>
    <h2>电气设计</h2>
    <p>为客户提供220kV、110kV及35kV的输变电工程设计、10kV及以下电压等级的配网工程设计，以及新能源、新基建领域的电力设计。</p>
    <ul class="img img2">
      <li></li>
      <li></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>
